import { render, staticRenderFns } from "./selectMach.vue?vue&type=template&id=6b506cae&scoped=true&"
import script from "./selectMach.vue?vue&type=script&lang=js&"
export * from "./selectMach.vue?vue&type=script&lang=js&"
import style0 from "./selectMach.vue?vue&type=style&index=0&id=6b506cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b506cae",
  null
  
)

export default component.exports